module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai423-d85682e910a2f198c5c3f1adb87a47f5.jpg";